import { CornerRadius } from '@picsart/design-system/foundation/cornerRadius';
import { Spacings } from '@picsart/design-system/foundation/spacings';
import { mediaQuery } from '@picsart/rc/helpers';
import { createUseStyles } from 'react-jss';

const useStyles = createUseStyles(
  () => ({
    root: {
      position: 'relative',
      overflow: 'hidden',
    },
    picture: {
      display: 'inline-flex',
      margin: [Spacings.s0, Spacings.s40],
      maxWidth: '100%',
      maxHeight: '100%',
      minWidth: 1000,
      borderRadius: CornerRadius.r8,
      overflow: 'hidden',
      height: 562,

      [mediaQuery(1365)]: {
        margin: [Spacings.s0, Spacings.s24],
        minWidth: 856,
        height: 478,
      },

      [mediaQuery(1023)]: {
        margin: [Spacings.s0, Spacings.s16],
        minWidth: 458,
        height: 256,
      },
    },
    image: {
      width: 1000,
      height: 596,
      maxWidth: '100%',
      maxHeight: 562,
      borderRadius: CornerRadius.r8,
      overflow: 'hidden',

      [mediaQuery(1365)]: {
        width: 856,
        maxHeight: 510,
      },

      [mediaQuery(1023)]: {
        width: 458,
        maxHeight: 256,
      },
    },
    imgWrapper: {
      minWidth: '100%',
      display: 'inline-flex',
    },
    skeletonCarousel: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      height: 562,
      marginTop: Spacings.s0,
      marginBottom: Spacings.s0,
      gap: 85,
    },
    skeletonSlide: {
      minWidth: '68%',
      height: '100%',
      borderRadius: CornerRadius.r8,
    },
  }),
  {
    name: 'home-page-carousel-desktop',
  },
);

export default useStyles;
